import React, { useState } from 'react';
import { Play, X } from 'lucide-react';

const SneakPeekBadge = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div
      data-testid="sneak-peek-badge"
      className="fixed bottom-6 left-4 z-30 hidden lg:block animate-fade-up"
    >
      <div
        className="bg-black border border-gold/30 rounded-xl px-4 py-3 flex items-center gap-3 shadow-2xl cursor-pointer group hover:border-gold/60 transition-all"
        onClick={() => document.getElementById('packages')?.scrollIntoView({ behavior: 'smooth' })}
      >
        <div className="w-9 h-9 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0 group-hover:bg-gold/30 transition-colors">
          <Play className="w-4 h-4 text-gold ml-0.5" />
        </div>
        <div>
          <p className="text-white text-sm font-bold leading-tight">Sneak peek in 72 hours.</p>
          <p className="text-gold text-xs font-semibold">Guaranteed.</p>
        </div>
        <button
          onClick={(e) => { e.stopPropagation(); setDismissed(true); }}
          className="text-white/30 hover:text-white/60 ml-1 flex-shrink-0"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

export default SneakPeekBadge;
